import { render, staticRenderFns } from "./chateau-calon-segur.vue?vue&type=template&id=3251ab08&scoped=true"
import script from "./chateau-calon-segur.vue?vue&type=script&lang=js"
export * from "./chateau-calon-segur.vue?vue&type=script&lang=js"
import style0 from "./chateau-calon-segur.vue?vue&type=style&index=0&id=3251ab08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3251ab08",
  null
  
)

export default component.exports